module.exports = __webpack_public_path__ + "static/assets/9e6209e3420343c4dc4ee0986651c2c7.svg";